import { render, staticRenderFns } from "./myPayElectricityFee.vue?vue&type=template&id=225fb6e5&scoped=true"
import script from "./myPayElectricityFee.vue?vue&type=script&lang=js"
export * from "./myPayElectricityFee.vue?vue&type=script&lang=js"
import style0 from "./myPayElectricityFee.vue?vue&type=style&index=0&id=225fb6e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225fb6e5",
  null
  
)

export default component.exports